"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEnterOrSpace = _interopRequireDefault(require("../../helpers/isEnterOrSpace"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = function LinkComponent(_ref) {
  var href = _ref.href,
      children = _ref.children,
      className = _ref.className,
      external = _ref.external,
      track = _ref.track;

  var trackEvent = function trackEvent(event) {
    event.preventDefault();
    track();

    if (external) {
      return window.open(href);
    }

    return window.location.assign(href);
  };

  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    tabIndex: 0,
    rel: "noopener noreferrer",
    target: external ? '_blank' : '_self',
    className: "link-wrapper ".concat(className),
    onClick: function onClick(event) {
      return track && trackEvent(event);
    },
    onKeyPress: function onKeyPress(event) {
      return track && (0, _isEnterOrSpace["default"])(event) && trackEvent(event);
    }
  }, children);
};

Link.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired,
  external: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  track: _propTypes["default"].func
};
Link.defaultProps = {
  className: '',
  external: false,
  track: undefined
};
var _default = Link;
exports["default"] = _default;